import InfiniteScrollLoader from "~/infiniteScrollLoader";
import { Hash } from "~/interfaces/hashInterfaces";
import {
  IModelInfiniteLoader,
  IInfiniteFetchOptions,
  IInfiniteFetchResults
} from "~/interfaces/infiniteScrollInterfaces";

export default abstract class BaseInfiniteLoader implements IModelInfiniteLoader {
  abstract _infiniteScrollLoader: InfiniteScrollLoader;

  fetch(incomingRequestParameters, functionOptions: Partial<IInfiniteFetchOptions> = {queryKey: "query"}): Promise<IInfiniteFetchResults> {
    return this._infiniteScrollLoader.fetch(incomingRequestParameters, functionOptions);
  }

  reset(): void {
    this._infiniteScrollLoader.lastRequestParameters = null;
  }
}